export default __webpack_public_path__ + "static/media/List-documentation.5cce19e1.md";